import { RowClassParams } from 'ag-grid-community';

import { defaultColDef } from '@/grid/defaults';

export const rowClassRules = {
  'fresh-shipment-form__row-shaded': (params: RowClassParams) =>
    params.rowIndex % 2 === 1,
};

export const FIELD_NAMES = {
  EMBRYO_COMMENT: 'embryoComment',
  IVF_COMMENT: 'ivfComment',
  PREDICTION_COMMENTS: 'predictionComments',
  PREDICTED_COMMENT_ONLY: 'predictedCommentOnly',
  FRESH_SHIPMENT_COMMENTS: 'freshShipmentComments',
  NO_EMBRYOS_PRODUCED: 'noEmbryosProduced',
  CONTAMINANT_PRESENT: 'contaminantPresent',
  PRIORITY: 'priority',
  CSR_COMMENT: 'csrComment',
  CSR_SHIPPED_TOG: 'shippedTog',
  CSR_SHIPPED_CLIENT: 'shipped',
} as const;

export const NO_EMBRYOS_PRODUCED_VALUE = 'NO_EMBRYOS_PRODUCED';
export const CONTAMINANT_PRESENT_VALUE = 'CONTAMINANT_PRESENT';

export const ShipmentEstimations: Record<string, string | number> = {
  OBJECT_TYPE_CODE: 10122,
  NAME: 'tog_shipmentestimations',
};

export const PREDICTION_COMMENTS_OPTIONS = [
  'Grainy',
  'Small Lipids',
  'Large Lipids',
  'Low Cell number',
  'Advanced',
  'Young',
  'Dark',
  'Hard to predict',
  'Nice embryos',
];

export const BILL_OPTIONS = [
  { text: '--', value: null },
  { text: 'Yes', value: 'true' },
  { text: 'No', value: 'false' },
];

export const gridOptions = {
  defaultColDef: {
    ...defaultColDef,
    filter: true,
  },
};

export const D5_VALUE = '100000000';

export const FRESH_EMBRYO_REQUIRED_HEADERS = [
  'embryoid',
  'sirebreed',
  'donorreg',
  'donorbreed',
  'strawno',
  'stage',
  'grade',
  'froze',
  'discard',
];
